import React from "react";
import {
  getCurrentCustomerId,
  getCurrentSiteId,
} from "../../redux/modules/route/routes";
import { connect } from "react-redux";
import OfficeAppButton from "../components/NavBar/OfficeAppButton";

type Props = {
  route: string;
};
const GoToAppButton = ({ route }: Props) => {
  const currentCustomerId = getCurrentCustomerId(route);
  const currentSiteId = getCurrentSiteId(route);

  return (
    <OfficeAppButton customerId={currentCustomerId} siteId={currentSiteId} />
  );
};

export default connect((state: any) => ({ route: state.route }))(GoToAppButton);
